import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const trackWebsiteSettingsDialogCanceled = ({ onDialogCancel }) => {
  onDialogCancel({
    dialogType: dialogTypes.WEBSITE_SETTINGS,
  });
};

export default trackWebsiteSettingsDialogCanceled;
